import { Brick, registerBrick } from 'olympe';
import ReactDOM from "react-dom";
import React from "react";
import LinearProgress from "@mui/material/LinearProgress";
import CircularProgress from "@mui/material/CircularProgress";

export default class StartLoadingPopup extends Brick {
    /**
     * Executed every time the brick receives a new trigger event.
     * Note that the method will be executed _even if_ an input (circularProgress, backgroundColor, text) is undefined.
     *
     * @protected
     * @param {BrickContext} context
     * @param {boolean} circularProgress
     * @param {olympe.df.Color} backgroundColor
     * @param {string} text
     * @param {function()} forwardEvent
     */
    onUpdate(context, [circularProgress, backgroundColor, text], [forwardEvent]) {
        const head = document.body;
        const loadingPopup = document.createElement('div');
        loadingPopup.id = 'loadingPopup017ba68e52cfa6db8329';
        loadingPopup.rel = 'stylesheet';
        loadingPopup.type = 'text/css';
        loadingPopup.className = 'loading-popup';
        head.appendChild(loadingPopup);

        document.getElementById('loadingPopup017ba68e52cfa6db8329').setAttribute('style', 'display: block');
        ReactDOM.render((<StartLoadingPopup.Component circularProgress={circularProgress} backgroundColor={backgroundColor} text={text} />), document.getElementById('loadingPopup017ba68e52cfa6db8329'));
        forwardEvent();
    }
}

StartLoadingPopup.Component = (props) => {
    return (
        <div
            style={{
                height: '100%',
                width: '100%',
                backgroundColor: props.backgroundColor.toHexString(),
                position: 'relative',
            }}>
            <div className={'loading-popup-text'}>{props.text}</div>
            {props.circularProgress ? <CircularProgress style={{
                    position: 'absolute',
                    top: '48%',
                    left: '48%',
                    width: '4%',
                    height: 'auto',
                }}/> :
                <LinearProgress className={'loading-popup-linear'}/>}
        </div>
    )
}

registerBrick('017ba68e52cfa6db8329', StartLoadingPopup);
